module.exports = __webpack_public_path__ + "static/media/M1-1-Koloryun-cod100.fede6232.png";